module.exports = __webpack_public_path__ + "img/portrait-068.dff61221.jpg";